import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Pill.module.css';
export function Pill({ variant, children, dot = false }) {
    return (_jsxs("span", { className: styles.pill, "data-variant": variant, children: [dot ? _jsx("span", { className: styles.dot, "aria-hidden": "true" }) : null, _jsx("span", { className: styles.label, children: children })] }));
}
//# sourceMappingURL=Pill.js.map